var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.headerCart }, [
    _c("div", { class: _vm.$style.headerPrice }, [
      _vm._v(_vm._s(_vm._f("currency")(_vm.orderTotalPrice)))
    ]),
    _vm._v(" "),
    _c("button", { class: _vm.$style.cartBtn, on: { click: _vm.toggleCart } }, [
      _c("svg", {
        directives: [{ name: "svg", rawName: "v-svg" }],
        class: _vm.$style.cartIcon,
        attrs: { symbol: "cart-icon-kiosk" }
      }),
      _vm._v(" "),
      _vm.cartLength
        ? _c("span", { class: _vm.$style.cartLabel }, [
            _vm._v("\n      " + _vm._s(_vm.cartLength) + "\n    ")
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/KioskCartIcon.vue?vue&type=template&id=376196c2&
// module id = null
// module chunks = 